import React from 'react';
import { xlate, xlationContext } from '../../../../framework/utils/i18n';
import { ComponentModel, getComponentId } from '../../parser/core';
import { ITimingSpecComponentModel } from '../../parser/timing-spec';
import { MarkdownContent } from '../content';
import { MarkdownTimedSection } from '../timing-section';

xlationContext('Presentual Markdown help viewer rendered element')

interface IPRIVATE_MARKDOWN_HELP_VIEWER_COMPONENTProps {
  model: ComponentModel;
}

export const PRIVATE_MARKDOWN_HELP_VIEWER_COMPONENT: React.FunctionComponent<IPRIVATE_MARKDOWN_HELP_VIEWER_COMPONENTProps> = (props) => {
  const { model } = props;
  const asSection = model as ITimingSpecComponentModel;

  return (
    <>
      {asSection.notes === undefined ?
      <MarkdownContent
        key={getComponentId(model)}
        componentModel={model}
        hostSectionIsTimed={false}
      />
      :
      <MarkdownTimedSection
        key={getComponentId(asSection)}
        componentModel={asSection}
        onClick={undefined}
        onToggleNotesSection={undefined}
        warningIconDescription={xlate('Section at risk of going overtime')}
        firmTimingTitle={xlate('The timing of this section is firm')}
        flexTimingTitle={xlate('The timing of this section is flexible')}
        shareTimingTitle={xlate('The timing of this section is a proportional share of the time remaining')}
        computedTimeShareDurationDescription={xlate('Share of remaining time and approximate section duration')}
        uncomputedTimeShareDurationDescription={xlate('Share of remaining time')}
        flexTimeDurationDescription={xlate('Approximate section duration')}
        firmTimeDurationDescription={xlate('Section duration')}
      />}
    </>
  );
};
